<div class="row justify-content-center g-0">
    <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
        @if(processing()) {
            <h2 class="text-center">
                <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
            </h2>
        }
        @if(!processing() && !game) {
            <ngb-alert type="danger">de wedstrijd kan niet gevonden worden</ngb-alert>
        }
        
        @if(!processing() && game){
        <div>

            <div class="d-flex justify-content-between">
                <h2>
                    <app-againstgame-title [againstGame]="game" [showFinishedDate]="false"></app-againstgame-title>
                </h2>
                <button (click)="navigateBack()" type="button" class="btn btn-outline-dark ms-1 position-relative">
                    <span>terug</span>                    
                </button>
            </div>

            <h4 class="text-center">opstellingen</h4>

            @if(processingLineups) {
                <h2 class="text-center">
                    <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
                </h2>
            }


            @if(!processingLineups) {
            <div class="d-flex justify-content-center">


                <div class="me-3">
                    <ng-container *ngTemplateOutlet="lineupSide; context: {lineupItems:getLineUp(HomeSide)}"></ng-container>
                </div>
                <div>
                    <ng-container *ngTemplateOutlet="lineupSide; context: {lineupItems:getLineUp(AwaySide)}">
                    </ng-container>
                </div>
            </div>
            }

            <h4 class="text-center mt-3">gebeurtenissen</h4>

            @if(processingEvents) {
                <h2 class="text-center">
                    <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
                </h2>
            }

            @if(!processingEvents) {
            <div class="d-flex justify-content-center">


                <div class="me-3">
                    <ng-container *ngTemplateOutlet="eventsSide; context: {eventItems:getEvents(HomeSide)}">
                    </ng-container>
                </div>
                <div>
                    <ng-container *ngTemplateOutlet="eventsSide; context: {eventItems:getEvents(AwaySide)}">
                    </ng-container>
                </div>
            </div>
            }

        </div>
        }

    </div>
</div>

<ng-template #lineupSide let-lineupItems="lineupItems">
    <ul class="list-group list-group-flush">
        @for(lineupItem of lineupItems; track lineupItem.getId()){
        <li class="list-group-item">
            <div>
                <app-lineicon [line]="lineupItem.player.getLine()"></app-lineicon>
                <span class="ps-1">{{lineupItem.player.getPerson().getName()}}</span>
            </div>
            @if(lineupItem.substitute) {
                <div>
                    <span class="px-2">{{lineupItem.substitute.minute}}'</span>
                    <app-lineicon [line]="lineupItem.substitute.player.getLine()"></app-lineicon>
                    <span class="ps-1">{{lineupItem.substitute.player.getPerson().getName()}}</span>
                </div>
            }
            @if(lineupItem.substitute && lineupItem.substitute.substitute) {
                <div>
                    <span class="ps-4 pe-2">{{lineupItem.substitute.substitute.minute}}'</span>
                    <app-lineicon [line]="lineupItem.substitute.substitute.player.getLine()"></app-lineicon>
                    <span class="ps-1">{{lineupItem.substitute.substitute.player.getPerson().getName()}}</span>
                </div>
            }
        </li>
        }
    </ul>
</ng-template>

<ng-template #eventsSide let-eventItems="eventItems">
    <ul class="list-group list-group-flush">
        @if(eventItems.length > 0) {
            @for(eventItem of eventItems;track eventItem.getId()){
                <li class="list-group-item">
                    <div>
                        <app-superelf-icon [icon]="getIconDefintion(eventItem)" [gameEvent]="getFootballEvent(eventItem)"></app-superelf-icon>
                        <span class="px-1">{{eventItem.minute}}'</span>
                        <span>{{eventItem.player.getPerson().getName()}}</span>
                    </div>
                    @if(eventItem.assistPlayer) {
                        <div>
                            <small class="px-3">a: {{eventItem.assistPlayer.getPerson().getName()}}</small>
                        </div>
                    }
                </li>
            }
        } @else {
            <div class="noEventItems"></div>
        }
    </ul>
</ng-template>